import { render } from "./TaskViewHeader.vue?vue&type=template&id=510ebb71"
import script from "./TaskViewHeader.vue?vue&type=script&lang=js"
export * from "./TaskViewHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__